
import { Link } from 'react-router-dom';

export default function Footer() {
  const services = [
    { name: 'Storage Solutions', href: '/storage' },
    { name: 'Laboratory Analysis', href: '/laboratory' },
    { name: 'Tank Leasing', href: '/tank-leasing' },
    { name: 'Maritime Shipping', href: '/maritime' },
    { name: 'Railway Shipping', href: '/railway' },
    { name: 'Motor Transport', href: '/motor-transport' },
  ];

  const quickLinks = [
    { name: 'About Us', href: '/about' },
    { name: 'Services', href: '/services' },
    { name: 'Terminals', href: '/terminals' },
    { name: 'Contact', href: '/contact' },
  ];

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-6 py-12 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/b824f6c6f8c5bf89267c8c03aa841c58/e4b31ee293d9e8ce5d706e9843c5ff08.png" 
                alt="SHENZHEN TONCENT Logo" 
                className="h-14"
              />
            </Link>
            <p className="text-sm leading-relaxed">
              Professional petroleum storage and shipping solutions with comprehensive logistics services.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              {services.map((item) => (
                <li key={item.name}>
                  <Link to={item.href} className="text-sm hover:text-teal-400 transition-colors cursor-pointer">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((item) => (
                <li key={item.name}>
                  <Link to={item.href} className="text-sm hover:text-teal-400 transition-colors cursor-pointer">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-teal-400 mt-1"></i>
                <span>Room 4029, North JUNYI Business Center, South of Lixin road, Huaide, Fuyong, Baoan district, Shenzhen, 518103</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-teal-400"></i>
                <a href="tel:+81675387393" className="hover:text-teal-400 transition-colors">+81675387393</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-sm text-center">
          <p>&copy; SHENZHEN TONCENT INT'L LOGISTICS CO.,LTD. All rights reserved. | <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-teal-400 transition-colors">Website Builder</a></p>
        </div>
      </div>
    </footer>
  );
}
